/**
 * Tujuan: Display tool stack icons with labels (Docker removed per user request)
 * Caller: About.js
 * Dependensi: react-icons
 * Main Functions: Toolstack()
 * Side Effects: None
 */
import React from "react";

import { VscVscode } from "react-icons/vsc";
import { SiVercel, SiFigma, SiTrello, SiGithub } from "react-icons/si";
import { IoLogoTableau } from "react-icons/io5";
import { SiLooker } from "react-icons/si";

function Toolstack() {
  return (
    <div className="tool-grid">

      <div className="tool-card">
        <VscVscode />
        <span className="tech-label">VS Code</span>
      </div>
      <div className="tool-card">
        <SiVercel />
        <span className="tech-label">Vercel</span>
      </div>
      <div className="tool-card">
        <IoLogoTableau />
        <span className="tech-label">Tableau</span>
      </div>
      <div className="tool-card">
        <SiLooker />
        <span className="tech-label">Looker</span>
      </div>
      <div className="tool-card">
        <SiFigma />
        <span className="tech-label">Figma</span>
      </div>
      <div className="tool-card">
        <SiTrello />
        <span className="tech-label">Trello</span>
      </div>
      <div className="tool-card">
        <SiGithub />
        <span className="tech-label">GitHub</span>
      </div>

    </div>
  );
}

export default Toolstack;
